import React from 'react';
import { Star } from 'lucide-react';
import { useFavorites } from '../../context/FavoritesContext';

const FavoriteStar = ({ itemId, size = 24, inline = false }) => {
  const { isFavorite, toggleFavorite, canToggleFavorites } = useFavorites();
  const isItemFavorite = isFavorite(itemId);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    // Allow toggling if in dev mode OR if API is configured (production with credentials)
    if (canToggleFavorites && isItemFavorite) {
      try {
        console.log('FavoriteStar: Toggling favorite via click', itemId);
        toggleFavorite(itemId);
      } catch (error) {
        console.error('Error in FavoriteStar click:', error);
      }
    }
  };

  // Only show star if item is favorited
  if (!isItemFavorite) {
    return null;
  }

  const containerClass = inline 
    ? "cursor-pointer flex-shrink-0" 
    : "absolute top-4 right-4 cursor-pointer z-10";

  return (
    <div
      className={containerClass}
      onClick={handleClick}
      // style={{ 
      //   filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))',
      // }}
    >
      <Star
        size={size}
        className="text-yellow-400 fill-yellow-400"
        // style={{
        //   filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.3))',
        // }}
      />
    </div>
  );
};

export default FavoriteStar;